import './Theme.Card.SidebarInfo.scss';
export default 'ThemeCardSidebarInfo';
